<template>
	<div class="body">
		<div class="body-container" v-if="targetData">

			<div class="title-ch">{{targetData.title}}</div>

			<el-table :data="targetData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="中职在校生（万人）" align="center" prop="middle">
					<template v-slot="{ row }">
						<label class="edit-label"
							@click="clickChangeData(row.id, row.year, 'middle', '中职在校生', row.middle)">{{row.middle}}</label>
					</template>
				</el-table-column>
				<el-table-column label="高职在校生（万人）" align="center" prop="high">
					<template v-slot="{ row }">
						<label class="edit-label"
							@click="clickChangeData(row.id, row.year, 'high', '高职在校生', row.high)">{{row.high}}</label>
					</template>
				</el-table-column>
				<el-table-column label="职业本科在校生（万人）" align="center" prop="vtl_uge">
					<template v-slot="{ row }">
						<label class="edit-label"
							@click="clickChangeData(row.id, row.year, 'vtl_uge', '职业本科在校生', row.vtl_uge)">{{row.vtl_uge}}</label>
					</template>
				</el-table-column>
				<el-table-column label="普通本科在校生（万人）" align="center" prop="normal_ben">
					<template v-slot="{ row }">
						<label class="edit-label"
							@click="clickChangeData(row.id, row.year, 'normal_ben', '普通本科在校生', row.normal_ben)">{{row.normal_ben}}</label>
					</template>
				</el-table-column>
			</el-table>
			<div class="source-note">注：表数据来源于统计年鉴，<label style="color: red;">如有错误，可点击修正</label>。</div>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog :title="dataTitle" :visible.sync="showDataDialog" append-to-body v-if="showDataDialog"
			align="center">

			<div class="data-ctr">
				<el-input v-model="dataValue" placeholder="请输入数值" class="data-input" />
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmData()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getMisEduData,
		updateMisData
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				introDialog: null,
				targetData: null,
				sourceData: null,
				cagrRateData: null,
				ftRateData: null,
				cagrData: null,
				ftData: null,
				showDataDialog: false,
				dataTitle: '',
				dataValue: ''
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['rowId'] = this.rowId;
				this.params['field'] = this.field;
				this.params['type'] = 'edu';
				this.params['value'] = this.dataValue;
				return this.params;
			},

			requestData() {
				getMisEduData(this.buildParams()).then(res => {
					let realData = res.data;
					this.targetData = realData;

				});
			},

			clickNext() {
				let path = '/mis_other?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},

			clickChangeData(id, year, field, name, value){
				let title = year + '年' + name;
				
				title += '数据修改';
				
				this.rowId = id;
				this.year = year;
				this.field = field;
				this.dataTitle = title;
				this.dataValue = value;
				this.showDataDialog = true;
			},

			clickConfirmData() {
				updateMisData(this.buildParams()).then(res => {
					this.requestData();
					this.showDataDialog = false;
				})
			}


		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "mis_edu.scss";
</style>